import { AxiosPromise } from 'axios';
import { libApiInstance } from '../axios';
import { Country } from './types/Country';
import { StateProvince } from './types/StateProvince';

export function requestCountries(signal?: AbortSignal): AxiosPromise<Country[]> {
    return libApiInstance.get('/resources/countries', { signal });
}

export function requestStateProvinces(
    countryCode: string | undefined,
    signal?: AbortSignal,
): AxiosPromise<StateProvince[]> {
    return libApiInstance.get(`/resources/statesProvinces/${countryCode}`, { signal });
}
